
const ListHeader = ({type, amount}) => {
    return (
        <div className={`${type === "in" ? "text-success" : "text-danger"} 
            list-group-item bg-transparent`}
            align="center">
            <i className={`bi ${type == "in" ? "bi-arrow-down-circle-fill" : "bi-arrow-up-circle-fill"} fs-5`}></i>
            <span className="fs-5 text-uppercase px-3">
                <b>{type == "in" ? "Cash In" : "Cash Out"}</b>
            </span>
            <div><i>({amount})</i></div>
        </div>
    )
  }

export default ListHeader;